// @flow
import { Badge, styled, Typography } from "@mui/material";
import React, { useContext } from 'react';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import {
	access_rights,
	access_roles,
	access_user,
	access_projects, access_parameters, access_registrations, access_reports, access_skills, access_rates,
} from "../../../../helpers/rights";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { ROUTE_PAGE_RATES_INDEX } from "../../../../modules/rates/routes/routes";
import {
	 ROUTE_PAGE_MOBILE_REGISTRATIONS_INDEX,
	ROUTE_PAGE_NEW_REGISTRATION,
	ROUTE_PAGE_REGISTRATIONS_INDEX
} from "../../../../modules/registrations/routes/routes";
import { ROUTE_PAGE_PARAMETERS_INDEX } from "../../../../modules/parameters/routes/routes";
import PermissionHOC from "../../../../modules/permission/components/permissionHOC/permissionHOC";
import { ROUTE_PAGE_PROJECTS_INDEX } from "../../../../modules/projects/routes/routes";
import { ROUTE_PAGE_REPORTS } from "../../../../modules/reports/routes/routes";
import { ROUTE_PAGE_RIGHTS_INDEX } from "../../../../modules/rights/routes/routes";
import { ROUTE_PAGE_SPECIALTIES_INDEX } from "../../../../modules/specialties/routes/routes";
import { ROUTE_PAGE_USERS_INDEX } from "../../../../modules/users/routes/routes";
import { ROUTE_PAGE_SECURITY_ROLES_INDEX } from "../../../../modules/usersSecurityRoles/routes/routes";
import { TitleContext } from "../../../../pages/main/content";

import {
	ROUTE_PAGE_HOME
} from "../../../../routers/routes";
import { useTranslation } from "react-i18next";
import { NAVIGATION } from "../../../../locales/components/namespaces";
import { menuStyle } from "../header/header";

type Props = {
	navItems: Array<{
		id: number,
		url: string,
		title: string
	}>
};

export const NotificationsIcon = (props: { fontSize: string }) => {
	return null;
}

const MainMenu = (props: Props) => {
	const { t } = useTranslation(NAVIGATION)
	const { count } = useContext(TitleContext)
	const NotificationButton = styled(Button)({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textTransform: 'none',
		color: '#1976d2',  // Customize color as needed
	});
	
	return (
		<Box sx={{ display: { xs: 'none', sm: 'none', md: 'flex' }, marginRight: 'auto', flexWrap: 'wrap' }}>
			<Box pr={2}>
				{/*<PermissionHOC requiredPermissions={[view_parent_dashboard, view_contractor_dashboard]}>*/}
				<Button
					component={Link}
					to={getRouteUrl(ROUTE_PAGE_HOME)}
					sx={{
						...menuStyle
					}}
				>
					{t('Home')}
				</Button>
				{/*</PermissionHOC>*/}
			</Box>
			
			<PermissionHOC requiredPermissions={[access_registrations]}>
				<Box pr={2}>
					<Button
						component={Link}
						//to={getRouteUrl(ROUTE_PAGE_REGISTRATIONS_INDEX)}
						to={getRouteUrl(ROUTE_PAGE_MOBILE_REGISTRATIONS_INDEX)}
						sx={{ ...menuStyle }}
					>
						{t('Registration History')}
					</Button>
				</Box>
			</PermissionHOC>

			<PermissionHOC requiredPermissions={[access_registrations]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_NEW_REGISTRATION)}
						sx={{ ...menuStyle }}
					>
						{t('New Registration')}
					</Button>
				</Box>
			</PermissionHOC>
		
			
			<PermissionHOC requiredPermissions={[access_projects]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_PROJECTS_INDEX)}
						sx={{ ...menuStyle }}
					>
						{t('Projects')}
					</Button>
				</Box>
			</PermissionHOC>
			
			<PermissionHOC requiredPermissions={[access_reports]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_REPORTS, {}, {section: "projects"})}
						sx={{ ...menuStyle }}
					>
						{t('Reports')}
					</Button>
				</Box>
			</PermissionHOC>
	
			<PermissionHOC requiredPermissions={[access_skills]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_SPECIALTIES_INDEX)}
						sx={{ ...menuStyle }}
					>
						{t('Specialties')}
					</Button>
				</Box>
			</PermissionHOC>
			
			{/*<PermissionHOC requiredPermissions={[access_parameters]}>*/}
			{/*	<Box pr={2}>*/}
			{/*		<Button*/}
			{/*			component={Link}*/}
			{/*			to={getRouteUrl(ROUTE_PAGE_PARAMETERS_INDEX)}*/}
			{/*			sx={{ ...menuStyle }}*/}
			{/*		>*/}
			{/*			{t('Costs')}*/}
			{/*		</Button>*/}
			{/*	</Box>*/}
			{/*</PermissionHOC>	*/}
			
			<PermissionHOC requiredPermissions={[access_user]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_USERS_INDEX,{role:1})}
						sx={{ ...menuStyle }}
					>
						{t('Workers')}
					</Button>
				</Box>
			</PermissionHOC>
			
			<PermissionHOC requiredPermissions={[access_user]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_USERS_INDEX,{role:0})}
						sx={{ ...menuStyle }}
					>
						{t('Users')}
					</Button>
				</Box>
			</PermissionHOC>
			
			<PermissionHOC requiredPermissions={[access_rates]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_RATES_INDEX)}
						sx={{ ...menuStyle }}
					>
						{t('Rates')}
					</Button>
				</Box>
			</PermissionHOC>
			
			
			<PermissionHOC requiredPermissions={[access_roles]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_SECURITY_ROLES_INDEX)}
						sx={{ ...menuStyle }}
					>
						{t('Roles')}
					</Button>
				</Box>
			</PermissionHOC>
			
			
			<PermissionHOC requiredPermissions={[access_rights]}>
				<Box pr={2}>
					<Button
						component={Link}
						to={getRouteUrl(ROUTE_PAGE_RIGHTS_INDEX)}
						sx={{ ...menuStyle }}
					>
						{t('Rights')}
					</Button>
				</Box>
			</PermissionHOC>
			
		
		</Box>
	)
		;
};

export default MainMenu